//
//  app-language-handler.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import Vue from 'vue';
import { LocaleMessages, LocaleMessageObject } from 'vue-i18n';

/*
 * Languages that can used by the app
 */
export enum AppLanguages {

    FR = 'fr',
    EN = 'en',

}

export abstract class AppLanguageHandler {

    /*
     * Transforms json strings to object to be used by Vuei18n
     */
    public static setApplicationMessages(): LocaleMessages {

        const messagesFR: LocaleMessageObject = {
            strings: require(`@/strings/fr/strings.json`),
            navigation: require(`@/strings/fr/navigation.json`),
        };

        const messagesEN: LocaleMessageObject = {
            strings: require(`@/strings/en/strings.json`),
            navigation: require(`@/strings/en/navigation.json`),
        };

        return {
            fr: messagesFR,
            en: messagesEN,
        };

    }

    /*
     * Determine the language based on the lang retrieved by the url
     */
    public static determineLang(context: Vue, lang: string, callback?: () => void): void {

        context.$i18n.locale = lang;
        document.getElementsByTagName('html')[0].lang = lang;

        context.$store.commit('dataModule/setAppLanguage', lang);

        // Callback can be usefull
        if (callback) { callback(); }

    }

}
